module.exports = __webpack_public_path__ + "static/media/S2N3-1.8fd049e6.svg";